module.exports = __webpack_public_path__ + "media/bootstrap-icons/question-diamond-890ed28b.svg";